import { ref } from "vue";

const alertBannerVisible = ref(false);
const alertBannerHeight = ref(0);
const dismissedBanners = ref<Set<string>>(new Set());

export function useAlertBanner() {
  const setVisible = (visible: boolean) => {
    alertBannerVisible.value = visible;
  };

  const setHeight = (height: number) => {
    alertBannerHeight.value = height;
  };

  const isDismissed = (identifier: string): boolean => {
    return dismissedBanners.value.has(identifier);
  };

  const markDismissed = (identifier: string) => {
    dismissedBanners.value.add(identifier);
  };

  return {
    isVisible: alertBannerVisible,
    height: alertBannerHeight,
    setVisible,
    setHeight,
    isDismissed,
    markDismissed,
  };
}
